import Vue from "vue";
import App from "./App.vue";
// import { sync } from "vuex-router-sync";
import router from "./router";
import store from "./store";
import ApiService from "./common/api.service";
import JwtService from "./common/jwt.service";
import { VERIFY_AUTH, LOAD_AUTH } from "./store/auth.module";
import { SET_APP_SECTION } from "./store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "bootstrap";
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";

// Vue 3rd party plugins
import i18n from "./common/plugins/vue-i18n";
import vuetify from "./common/plugins/vuetify";
import "./common/plugins/bootstrap-vue";
import "./common/plugins/perfect-scrollbar";
import "./common/plugins/highlight-js";
import "@babel/polyfill";
import "@mdi/font/css/materialdesignicons.css";

import Vue2Filters from "vue2-filters";

import { ALERT_TYPES } from "./consts";

import Dialog from "@/views/partials/content/Dialog.vue";
import { mapGetters } from "vuex";

// API service init
ApiService.init(store);

// Remove this to disable mock API
// MockService.init();

// Auth Prototype

const AuthPlugin = {
  install: function(Vue, ...args) {
    const auth = () => {
      var permissions = [];
      var hasRole = null;
      var hasPermission = null;
      var ability = null;

      var _store = args[0].store;

      const user = _store.state.auth.user;

      var roles = user
        ? [...(user.role ? [user.role] : []), ...(user.roles ? user.roles : [])]
        : [];

      if (roles.length) {
        roles.map(role => {
          permissions = permissions.concat(...(role.permissions || []));
        });
      }

      hasRole = (val, checkId) => {
        return (
          roles.findIndex(role => {
            return checkId ? role.id == val : role.name == val;
          }) > -1
        );
      };

      hasPermission = permission_name => {
        return (
          permissions.findIndex(permission => {
            return permission.name == permission_name;
          }) > -1
        );
      };

      ability = permission => {
        if (user) {
          if (hasRole("root")) {
            return true;
          }

          if (!permissions.length) {
            return false;
          }

          return hasPermission(permission);
        }
        return false;
      };

      return {
        // init,
        user,
        roles,
        permissions,
        hasRole,
        hasPermission,
        can: ability
      };
    };

    Vue.prototype.$auth = auth;
    Vue.prototype.$can = auth().can;
  }
};

Vue.use(AuthPlugin, { store: store });

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch(LOAD_AUTH)]).then(next);

  /*
  const meta = this.$route.meta;

    if (meta && meta.section) {
      this.$store.dispatch(SET_APP_SECTION, meta.section);
    }
  */
  var section = "default";
  var sectionSet = false;

  if (
    to.matched.some(record => {
      return (
        record.meta.section === "admin" ||
        record.meta.section === "affiliate" ||
        record.meta.section === "vendor"
      );
    })
  ) {
    to.matched.some(record => {
      store.dispatch(SET_APP_SECTION, record.meta.section);
      sectionSet = true;
    });
  } else {
    store.dispatch(SET_APP_SECTION, "default");
  }

  /*

  if (
    to.name &&
    to.matched.some(dest => {
      console.log(dest);
      return dest.name.endsWith("login") || dest.name.endsWith("register");
    })
  ) {
    */

  if (
    to &&
    to.name &&
    (to.name.endsWith("login") || to.name.endsWith("register"))
  ) {
    section = store.state.config.section;

    if (!JwtService.isTokenExpired()) {
      store.dispatch(LOAD_AUTH, section);

      if (store.state.auth.isAuthenticated) {
        var pref = section === "" || section === "default" ? "" : section + "-";
        next({ name: `${pref}dashboard` });
      }
    }
  } else {
    if (sectionSet) {
      section = store.state.config.section;
      store.dispatch(LOAD_AUTH, section);
    } else {
      store.dispatch(LOAD_AUTH, "default");
    }

    const route_prefix = section === "default" ? "" : section + "-";

    if (!store.state.auth.isAuthenticated || JwtService.isTokenExpired()) {
      next({ name: `${route_prefix}login` });
    }
  }

  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

// sync(store, router);

const DialogPlugin = {
  install: function(Vue) {
    // Vue.directive("hasConfirm", {
    //   bind(el, binding) {
    //     let node = document.createElement("div");
    //     node.setAttribute("id", binding.value);
    //     el.appendChild(node);
    //   }
    // });
    Vue.prototype.$dialog = null;

    Vue.prototype.$confirm = function(args) {
      var ComponentClass = Vue.extend(Dialog);

      if (this.$dialog !== null) {
        this.$dialog.$destroy();
        this.$dialog = null;
      }

      var instance = new ComponentClass({
        vuetify,
        propsData: { confirmOnly: false, ...args }
      });

      const dia = instance.$mount();

      this.$dialog = dia;
      return instance;
    };

    Vue.prototype.$alert = function(args) {
      var ComponentClass = Vue.extend(Dialog);

      if (this.$dialog !== null) {
        this.$dialog.$destroy();
        this.$dialog = null;
      }

      var instance = new ComponentClass({
        vuetify,
        propsData: { confirmOnly: true, ...args }
      });

      const dia = instance.$mount();

      this.$dialog = dia;
      return instance;
    };
  }
};

Vue.use(DialogPlugin);

Vue.prototype.$scrollToTop = () =>
  window.scroll({ top: 0, left: 0, behavior: "smooth" });

Vue.mixin({
  data: function() {
    return {
      storeNamespace: null,
      loadingMessage: "Please wait...",
      notification: {
        show: false,
        countDown: 5,
        message: "",
        type: ALERT_TYPES.Primary,
        callback: false
      },
      paystackLoaded: false,
      configLoaded: false,
      transactionTypes: {
        affiliate_registration: "AFFILIATE_REGISTRATION",
        vendor_registration: "VENDOR_REGISTRATION",
        order_payment: "ORDER_PAYMENT"
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log("Route Entered", to, from);

  //   next();
  // },
  methods: {
    showNotification(message, type, show, countDownSeconds, dismissCallback) {
      this.notification.type = type;
      this.notification.message = message;
      this.notification.countDown = countDownSeconds;
      this.notification.show = show || countDownSeconds;

      if (dismissCallback) {
        this.notification.callback = dismissCallback;
      } else {
        this.notification.callback = false;
      }
    },
    countDownNotification() {
      if (this.notification.countDown > 0) {
        this.notification.countDown--;
      } else {
        this.notification.show = false;
      }
    },
    notificationDismissed() {
      this.notification.show = false;
      this.notification.message = "";
      this.notification.countDown = 0;

      if (
        this.notification.callback &&
        typeof this.notification.callback == "function"
      ) {
        this.notification.callback();
      }
    },
    setLoading(loading, message) {
      if (message) {
        this.loadingMessage = message;
      }

      this.$store.commit(this.addNamespace("isLoading"), loading);
    },
    addNamespace(action) {
      return `${this.storeNamespace}/${action}`;
    },
    userRoles() {
      if (this.isAuthenticated && this.currentUser) {
        return [...[this.currentUser.role], ...this.currentUser.roles];
      }

      return [];
    },
    userPermissions() {
      var roles = this.userRoles();

      if (roles.length) {
        let permissions = [];

        roles.map(role => {
          permissions = permissions.concat(...role.permissions);
        });

        return permissions;
      }

      return [];
    },
    userHasRole(val, checkId) {
      return (
        this.userRoles().findIndex(role => {
          return checkId ? role.id == val : role.name == val;
        }) > -1
      );
    },
    userHasPermission(permission_name) {
      return (
        this.userPermissions().findIndex(permission => {
          return permission.name == permission_name;
        }) > -1
      );
    },
    userCan(permission) {
      if (this.isAuthenticated && this.currentUser) {
        if (!this.currentUser.role) {
          return false;
        }

        let roles = [...[this.currentUser.role], ...this.currentUser.roles];
        let permissions = [];

        roles.map(role => {
          // console.log(role.permissions);
          permissions = permissions.concat(...role.permissions);
        });

        if (permissions.length) {
          // console.log(permissions);
          return (
            permissions.findIndex(perm => {
              // console.log(perm, permission, idx);
              return perm.name == permission;
            }) > -1
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    itemIndex(items, item, key) {
      var sKey = key ? key : "id";

      return items.findIndex(value => item[sKey] === value[sKey]);
    },
    loadPaystack() {
      const script = document.createElement("script");
      script.src = "https://js.paystack.co/v1/inline.js";
      document.getElementsByTagName("head")[0].appendChild(script);

      return new Promise(resolve => {
        var cb = () => {
          Vue.prototype.$paystack = window.PaystackPop;

          resolve();
        };

        if (script.readyState) {
          // IE
          script.onreadystatechange = () => {
            if (
              script.readyState === "loaded" ||
              script.readyState === "complete"
            ) {
              script.onreadystatechange = null;
              cb();
            }
          };
        } else {
          // Others
          script.onload = () => {
            cb();
          };
        }
      });
    },
    paystackPay(options) {
      this.$paystack.setup(options).openIframe();
    }
  }
});

Vue.use(Vue2Filters);
Vue.use(require("vue-moment"));

new Vue({
  store,
  router,
  i18n,
  vuetify,
  mixins: [Vue2Filters.mixin],
  render: h => h(App)
}).$mount("#app");
